import { create } from "zustand";

export interface ForgeJob {
  masterId: string;
  cepaName: string;
  connectionName: string;
  status: "forging" | "completed" | "error";
  mcpToolsCount?: number;
  endpointsCount?: number;
  error?: string;
  startedAt: number;
  completedAt?: number;
}

interface ForgeStore {
  activeForge: ForgeJob | null;
  startForge: (
    job: Pick<ForgeJob, "masterId" | "cepaName" | "connectionName">
  ) => void;
  completeForge: (data: {
    mcpToolsCount: number;
    endpointsCount: number;
  }) => void;
  failForge: (error: string) => void;
  dismissForge: () => void;
}

export const useForgeStore = create<ForgeStore>((set) => ({
  activeForge: null,

  startForge: (job) =>
    set({
      activeForge: {
        ...job,
        status: "forging",
        startedAt: Date.now(),
      },
    }),

  completeForge: (data) =>
    set((state) => ({
      activeForge: state.activeForge
        ? {
            ...state.activeForge,
            status: "completed",
            mcpToolsCount: data.mcpToolsCount,
            endpointsCount: data.endpointsCount,
            completedAt: Date.now(),
          }
        : null,
    })),

  failForge: (error) =>
    set((state) => ({
      activeForge: state.activeForge
        ? { ...state.activeForge, status: "error", error }
        : null,
    })),

  dismissForge: () => set({ activeForge: null }),
}));
